import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['Marcos', 'Lucía', 'Federico', 'Ana', 'Gastón', 'Sofía', 'Pablo', 'Valentina', 'Facundo', 'Camila'];
const CITIES = ['Pergamino', 'Rosario', 'Córdoba', 'Mendoza', 'Rafaela', 'Tandil', 'Venado Tuerto', 'Río Cuarto', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initial = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      setTimeout(showPopup, Math.random() * 5000 + 10000);
    }, 15000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-185">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-[#0B1F17] border-4 border-[#D4A843] rounded-xl shadow-2xl p-2.5 max-w-[260px] flex items-center gap-2.5" data-id="element-186">
          <div className="bg-[#102A1F] p-1.5 rounded-full flex-shrink-0 border border-[#74C69D]/30" data-id="element-187">
            <ShoppingBagIcon className="w-4 h-4 text-[#74C69D]" data-id="element-188" />
          </div>
          <div data-id="element-189">
            <p className="text-[11px] font-black text-white uppercase leading-tight" data-id="element-190">
              {data.name} de {data.city}
            </p>
            <p className="text-[9px] text-[#D4A843] font-bold uppercase tracking-wide leading-tight mt-0.5" data-id="element-191">
              acaba de comprar el Kit de Producción Forestal
            </p>
            <p className="text-[8px] text-[#BFC9C5] font-bold mt-0.5 uppercase" data-id="element-192">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}